import { AI_FEATURES_OPEN } from 'src/constants/ai-features';

/**
 * AI chat 표면을 화면에 낼지 — 앱 안의 AI 스위치(`constants/ai-features`)를 그대로 따른다.
 *
 * 끄면 세 자리가 함께 사라진다:
 * ① 소재 찾기의 담기(`+`) 단추 · 담은 소재 기둥 · 질문 다이얼로그
 * ② 브랜드 허브의 AI chat 독
 * ③ 크리에이터 허브의 AI chat 독
 *
 * 🔑 **배선은 그대로 둔다** — 장바구니 훅·질문 훅·보관함 라우트(`/service/ai-chat`)의 코드는 살아 있다.
 * ⚠️ 따로 켜고 끄지 않는다 — 스위치는 `AI_FEATURES_OPEN` 하나다.
 */
export const AI_CHAT_VISIBLE = AI_FEATURES_OPEN;
